import React from 'react';
import { Box, Flex, Text } from '@zillow/constellation-10';
import { useTransactionInformation } from 'src/store/useTransactionInformation';
import { NotYourHome } from '../NotYourHome';
import { SystemStyleObject } from '@/styled-system/types';

interface IAccessCodeInfoBlockProps {
  css?: SystemStyleObject;
  fixedWidth?: boolean;
}

export const AccessCodeInfoBlock: React.FC<IAccessCodeInfoBlockProps> = ({ css, fixedWidth = true }) => {
  const { data } = useTransactionInformation();

  return (
    <>
      {data && (
        <>
          {fixedWidth && <Box css={{ flexGrow: 1, ...css }}></Box>}
          <Flex
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: fixedWidth ? 'flex-end' : 'center',
              width: fixedWidth ? '50%' : 'auto',
              ...css,
            }}
          >
            <Text css={{ textAlign: 'right', textStyle: 'body-sm-bold' }}>
              {data.address.streetAddress} {data.address.unit}
            </Text>
            <NotYourHome />
          </Flex>
        </>
      )}
    </>
  );
};
